import { render, staticRenderFns } from "./OutboundTransfersDataTable.template.vue?vue&type=template&id=0d6bbd7a&scoped=true&"
var script = {}
import style0 from "./OutboundTransfersDataTable.template.vue?vue&type=style&index=0&id=0d6bbd7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6bbd7a",
  null
  
)

export default component.exports